import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

const DonorsByCollectionSiteChart = ({ data }) => {
  const { t } = useTranslation();

  const chartData = useMemo(() => {
    if (!data) return null;

    return {
      labels: [t("Fixed Site"), t("Mobile Drive"), t("Hospital")],
      datasets: [
        {
          label: t("Number of Donors"),
          data: [data.fixedSite, data.mobileDrive, data.hospital],
          backgroundColor: ["#3b4cb8", "#28a745", "#dc3545"],
          borderColor: ["#3b4cb8", "#28a745", "#dc3545"],
          borderWidth: 1,
          barThickness: 40,
          borderRadius: 4,
        },
      ],
    };
  }, [data, t]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            fontColor: "#666",
          },
          gridLines: {
            color: "rgba(0, 0, 0, 0.1)",
          },
          scaleLabel: {
            display: true,
            labelString: t("Number of Donors"),
            fontColor: "#666",
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            fontColor: "#666",
          },
          gridLines: {
            display: false,
          },
          scaleLabel: {
            display: true,
            labelString: t("Collection Site"),
            fontColor: "#666",
          },
        },
      ],
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem) => {
          return `${t("Donors")}: ${tooltipItem.yLabel}`;
        },
      },
    },
  };

  if (!chartData) {
    return <p className="text-center mt-3">{t("No data available")}</p>;
  }

  return (
    <div style={{ minHeight: "300px", position: "relative" }}>
      <Bar data={chartData} height={300} options={options} />
    </div>
  );
};

export default DonorsByCollectionSiteChart;
